var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{attrs:{"id":"loader-wrapper"}},[_c('div',{staticClass:"loader"}),_c('div',{staticClass:"load_title"},[_vm._v(_vm._s(_vm.$t('components.loading.loading.title')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }